import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";

import {quicksandBold} from "@/GlobalStyle";

export interface Navigation {
  libelle: string;
  url: string;
  droit?: boolean;
}
interface NavListStyleType {
  $isCollapsed: boolean;
  $isOpen: boolean;
  $haveNavigation: boolean;
}

const NavListStyle = styled.ul<NavListStyleType>`
  display: flex;
  flex-wrap: ${({$isCollapsed}) => ($isCollapsed ? "wrap" : "nowrap")};
  width: min-content;
  gap: 2.5rem;
  background-color: white;
  // Permet de gérer l'affichage en version mobile.
  margin: ${({$isCollapsed, $isOpen}) =>
    $isCollapsed && !$isOpen ? "0" : "0"};
  overflow: ${({$isCollapsed, $isOpen}) =>
    $isCollapsed && !$isOpen ? "hidden" : "hidden"};
  max-height: ${({$isCollapsed, $isOpen}) =>
    $isCollapsed && !$isOpen ? "0px" : "max-content"};
  // on enleve le padding si on a pas de navigation (notamment sur la vue fournisseur)
  // sinon le padding change quand la navigation est plus grande que l'ecran.
  padding: ${({$isCollapsed, $isOpen, $haveNavigation}) =>
    $isCollapsed && !$isOpen
      ? "0 2.5rem 0 2.5rem"
      : !$haveNavigation
        ? "0 1px 0 0"
        : "25px 2.5rem 25px 2.5rem"};
`;

const NavListElementStyle = styled.a`
  font-weight: bold;
  font-size: 1.25rem;
  color: ${({theme}) => theme.colors.darkPrimary};
  list-style: none;
  min-width: 130px;
  text-align: center;
  position: relative;
  ${quicksandBold};

  &::before {
    position: absolute;
    bottom: -8px;
    left: 0;
    content: "";
    height: 2px;
    background-color: ${({theme}) => theme.colors.mediumSecondary};
    width: 100%;
  }

  &:hover {
    cursor: pointer;
    &::before {
      height: 3px;
    }
  }
`;

export function Navigation({
  navigation,
  navRef,
  isCollapsed,

  isOpen,
  setNavIsOpen,
}: {
  navigation: Navigation[];
  navRef: React.RefObject<HTMLUListElement | null>;
  isCollapsed: boolean;
  initialNavWidth: null | number;
  isOpen: boolean;
  setNavIsOpen: (isOpen: boolean) => void;
}): ReactElement {
  const navigate = useNavigate();

  return (
    <NavListStyle
      ref={navRef}
      $isCollapsed={isCollapsed}
      $isOpen={isOpen}
      $haveNavigation={navigation?.length ? true : false}
      data-testid="NavListStyle">
      {navigation.map((nav, index) =>
        nav?.droit === undefined || nav?.droit === true ? (
          <NavListElementStyle
            key={index}
            href={nav.url}
            data-testid={`NavListElementStyle-${index}`}
            onClick={e => {
              e.preventDefault();

              navigate(nav.url);
              if (isCollapsed) {
                setNavIsOpen(false);
              }
            }}>
            {nav.libelle}
          </NavListElementStyle>
        ) : null
      )}
    </NavListStyle>
  );
}
